// extracted by mini-css-extract-plugin
export default {"main_wrapper":"styles_main_wrapper__0RTlM","title":"styles_title__G8Obu","parallax_container":"styles_parallax_container__uZCK0","parallax_item":"styles_parallax_item__douD6"};